<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section class="widget-section widget-section--filter flex no-wrap items-center q-mb-lg">
      <q-form ref="form" class="full-width">
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.id"
              label="Item ID"
              outlined
              dense
              clearable
              class="full-width"
              :rules="[validateUuid]"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.registrationId"
              label="Registration ID"
              outlined
              dense
              clearable
              :rules="[validateUuid]"
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.sourceIp"
              label="Source IP"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.targetIp"
              label="Target IP"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.sourceApmId"
              label="Source APMID"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.targetApmId"
              label="Target APMID"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
        </div>
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.sourceServiceName"
              label="Source name"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.targetServiceName"
              label="Target name"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.sourceDatacenter"
              label="Source location"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.targetDatacenter"
              label="Target location"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.sourceEnv"
              label="Source env"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
            <q-input
              v-model="filters.targetEnv"
              label="Target env"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="filterTable"
            ></q-input>
          </div>
        </div>
        <div class="row no-wrap full-width q-mt-sm q-col-gutter-sm">
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.port"
              label="Port"
              outlined
              dense
              clearable
              @update:model-value="filterTable"
              class="full-width"
            ></q-input>
            <q-select
              v-model="filters.protocol"
              :options="[
                { label: 'TCP', value: 'tcp' },
                { label: 'UDP', value: 'udp' },
                { label: 'ICMP', value: 'icmp' },
              ]"
              emit-value
              map-options
              options-dense
              label="Protocol"
              outlined
              dense
              clearable
              class="full-width"
              @update:model-value="reloadTable"
            ></q-select>
            <StatusSelect
              v-model="filters.status"
              @update:model-value="reloadTable"
              class="full-width"
              @clear="reloadTable"
              :options="['inprogress', 'completed', 'failed', 'removed']"
            />
          </div>
          <div class="col flex no-wrap q-col-gutter-sm">
            <q-input
              v-model="filters.changeNumber"
              label="Change request number"
              outlined
              dense
              clearable
              @update:model-value="filterTable"
              class="full-width"
            ></q-input>
            <DatePicker
              v-model="filters.dateFrom"
              @update:model-value="reloadTable"
              label="Created after"
              class="full-width"
              @clear="
                () => {
                  filters.dateFrom = undefined;
                }
              "
            />
            <DatePicker
              v-model="filters.dateTo"
              @update:model-value="reloadTable"
              label="Created before"
              class="full-width"
              @clear="
                () => {
                  filters.dateTo = undefined;
                }
              "
            />
          </div>
        </div>
      </q-form>
      <q-icon @click="resetFilters" name="engp:engp-ico-restart" class="q-ml-md cursor-pointer" size="20px">
        <q-tooltip>Reset</q-tooltip>
      </q-icon>
    </section>
    <section class="widget-section widget-section--table">
      <div class="flex items-center q-ml-sm q-mb-sm">
        <span>Show segments</span>
        <q-toggle keep-color class="custom-toggle" :dark="false" color="primary" v-model="showIps"> </q-toggle>
        <span>Show IP's</span>
      </div>
      <FirewallRulesTable mode="list" ref="firewallRules" class="fixed-table" :filters="filters" :showIps="showIps" />
    </section>
  </q-page>
</template>

<script>
import StatusSelect from './components/StatusSelect.vue';
import DatePicker from './components/DatePicker.vue';
import FirewallRulesTable from '@/shared/components/FirewallRulesTable.vue';

export default {
  name: 'FirewallRules',
  components: {
    StatusSelect,
    DatePicker,
    FirewallRulesTable,
  },
  data() {
    return {
      showIps: true,
      loading: false,
      timeout: undefined,
      filters: {
        id: undefined,
        registrationId: undefined,
        infraService: undefined,
        changeNumber: undefined,
        sourceIp: undefined,
        targetIp: undefined,
        sourceApmId: undefined,
        targetApmId: undefined,
        sourceServiceName: undefined,
        targetServiceName: undefined,
        sourceEnv: undefined,
        targetEnv: undefined,
        sourceDatacenter: undefined,
        targetDatacenter: undefined,
        port: undefined,
        protocol: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    validateUuid(value) {
      const uuidRegex =
        // eslint-disable-next-line
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return value?.length ? uuidRegex.test(value) || 'Must be a valid UUID' : true;
    },
    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
      });
      this.reloadTable();
    },
    reloadTable() {
      this.$refs.firewallRules.reload();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
  },
  mounted() {
    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      this.filters[key] = query[key] || undefined;
    });
    this.reloadTable();
  },
};
</script>

<style lang="scss" scoped>
.long-desc {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.showBanner {
  .fixed-table {
    height: calc(100vh - 470px);
  }
}
.fixed-table {
  height: calc(100vh - 410px);
}
</style>
